import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
// import { toast } from "react-toastify";

import { API_GET_ACCOUNT_NAME } from "../../../config/api";
import { showErrorModal } from "../../reducers/messageSlice";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";

export const getAccountName = createAsyncThunk(
  "users/getAccountName",
  async (
    { payload, cb, setgettingAccountName, deleteLastDegit },
    { dispatch }
  ) => {
    try {
      const { data } = await Client({
        method: "POST",
        path: API_GET_ACCOUNT_NAME,
        data: payload,
      });

      if (data?.status === true || data?.status === "success") {
        cb(data?.data?.account_name);
      } else {
        dispatch(showErrorModal(data?.message || "An error has occurred"));
        // toast.error(data?.message || "An error has occurred");

        deleteLastDegit();
        setgettingAccountName(false);
      }

      // return response?.data;
    } catch (error) {
      setgettingAccountName(false);
      const msg = proccessErrorMessage(error);
      deleteLastDegit();
      dispatch(showErrorModal(msg));

      throw error;
    }
  }
);
